import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { RegisterRef } from '~types/company';
import { isClient } from '~utils/lodash/isServer';

import Card from '../Card';
import CultureSection from './CultureSection';
import { useDisplayTrigger } from './hooks';
import SkillSection from './SkillSection';
import * as S from './style';
import WorkLifeSection from './WorkLifeSection';

interface Props {
  registerRef: RegisterRef;
}

export default function ReviewInfo({ registerRef }: Props) {
  const router = useRouter();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const isDisplay = useDisplayTrigger(wrapperRef);

  useEffect(() => {
    const [path, hash] = router.asPath.split('#');

    if (wrapperRef.current && hash === 'company-review-chart' && isClient) {
      router.replace(path);
      wrapperRef.current.scrollIntoView();
    }
  }, [router.asPath]);

  return (
    <Card title='다녀본 리뷰' sectionId='company-review' registerRef={registerRef}>
      <S.Contents ref={wrapperRef}>
        <WorkLifeSection isDisplay={isDisplay} />
        <CultureSection isDisplay={isDisplay} />
        <SkillSection isDisplay={isDisplay} />
      </S.Contents>
    </Card>
  );
}
